import { registerPlugin } from '@capacitor/core';
const CapacitorIvsPlayer = registerPlugin('CapacitorIvsPlayer', {
    web: () => import('./web').then((m) => new m.CapacitorIvsPlayerWeb()),
});
export * from './definitions';
export { CapacitorIvsPlayer };
//# sourceMappingURL=index.js.map